import React, { createContext, ReactElement, useMemo } from 'react';

// project import
import config from '../config';

// initial state
const initialState: typeof config = {
  ...config,
};

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const ConfigContext = createContext(initialState);

type ConfigProviderProps = {
  children: ReactElement;
};

function ConfigProvider({ children }: Readonly<ConfigProviderProps>) {
  const memoizedValue = useMemo(() => ({ ...config }), []);

  return (
    <ConfigContext.Provider value={memoizedValue}>
      {children}
    </ConfigContext.Provider>
  );
}

export { ConfigProvider, ConfigContext };
